<template>
  <div v-if="productType==='plot'" class="container">
    <unit-title title="地块信息" />
    <template v-if="farmLandData.latLng">
      <div class="label">
        种植地块:
      </div>
      <wh-map-draw
        class="land-map"
        :editable="false"
        :geometry-j-s-o-n="farmLandData.latLng"
      />
    </template>
    <farm-land-iot-device :user-id="userId" />
  </div>
  <div v-else class="container">
    <farm-land-iot-device :user-id="userId" />
  </div>
</template>

<script>
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
import WhMapDraw from '@/components/public/WhMapDraw/WhMapDraw'
import FarmLandIotDevice from '@/views/productManage/TraceSource/components/FarmLandIotDevice'
export default {
  name: 'FarmLandData',
  components: { FarmLandIotDevice, WhMapDraw, UnitTitle },
  props: {
    userId: {
      type: Number,
      default: undefined
    },
    traceData: {
      type: Object,
      default() {
        return {}
      }
    },
    productType: {
      type: String,
      default: 'plot'
    }
  },
  data() {
    return {
      sensor: {
        soilNutrient: [],
        soilStatus: [],
        weather: []
      }
    }
  },
  computed: {
    farmLandData() {
      return this.traceData.land || {}
    }
  }
}
</script>

<style lang='less' scoped>
.label {
  font-size: 14px;
  font-weight: 400;
  color: #323332;
  margin-top: 10px;
}
.land-map {
  margin-top: 18px;
  height: 342px;
  padding-bottom: 24px;
  /*border-bottom: 1px solid #d6d6d6;*/
}
.no-border{
   border:none;
   margin:0
}
</style>
